import { REGEX } from '@/config/regex.constants';
import { en } from '@/lib/i18n/en_labels';

// Registry of available locales. Add a locale by importing its labels here.
const LOCALES = { en };
export const DEFAULT_LOCALE = 'en';

// Unknown tokens are left as-is so they surface during development.
const interpolate = (template, vars) => {
  if (!vars) return template;
  return template.replace(REGEX.I18N_INTERPOLATION, (match, name) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match,
  );
};

// Pure resolver (no React). Falls back to the default locale, then the raw key.
export const getTranslation = (key, vars, locale = DEFAULT_LOCALE) => {
  const labels = LOCALES[locale] ?? LOCALES[DEFAULT_LOCALE];
  const template = labels[key] ?? LOCALES[DEFAULT_LOCALE][key] ?? key;
  return interpolate(template, vars);
};
